import React from 'react'

interface Props { };

export function NotFound(props: Props) {
    return (
        <div className="notFound">
            NotFound
        </div>
    )
}
